import "./App.css";

import React from "react";
import { BrowserRouter as Router } from "react-router-dom";
import CustomLayout from "./components/Layout";

const App = () => {
  return (
    <Router>
      <CustomLayout />
    </Router>
  );
};

export default App;
